import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Marketing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to dashboard as this module has been moved/disabled for employers
    navigate('/check', { state: { message: 'Marketing module is no longer available.' } });
    // Or just navigate back
    navigate(-1);
  }, [navigate]);

  return null;
};

export default Marketing;
